interface CustomEvent {
  id: number;
  attributes?: Record<string, string>;
  textContent?: string;
}

export interface CustomEventList {
  a: CustomEvent[];
  b: CustomEvent[];
  c: CustomEvent[];
  d: CustomEvent[];
}

const isValidEvent = (eventList: CustomEvent[]): boolean =>
  typeof eventList !== 'undefined' && eventList.length > 0;

/* eslint-disable no-console */
export function debugEvent(
  eventType: string,
  event: CustomEventList,
  relatedDomNode: unknown,
): void {
  if (eventType === 'mutation') {
    if (isValidEvent(event.a)) {
      event.a.forEach(({ id }: Pick<CustomEvent, 'id'>) => {
        console.debug(`MUTATION: Removed node ${id}`);
        console.debug(`pageDom.idMap: `, relatedDomNode);
      });
    }
    if (isValidEvent(event.b)) {
      event.b.forEach((_event: CustomEvent) => {
        console.debug(`MUTATION: Added or changed node ${_event.id}`);
        console.debug(relatedDomNode);
        console.debug(_event);
      });
    }
    if (isValidEvent(event.c)) {
      event.c.forEach(({ id, attributes }: Pick<CustomEvent, 'id' | 'attributes'>) => {
        console.debug(`MUTATION: Attribute changed for node ${id}`);
        console.debug(relatedDomNode);
        console.debug(attributes);
      });
    }
    if (isValidEvent(event.d)) {
      event.d.forEach(({ id, textContent }: Pick<CustomEvent, 'id' | 'textContent'>) => {
        console.debug(`MUTATION: Text set for node ${id}`);
        console.debug(relatedDomNode);
        console.debug(textContent);
      });
    }
  } else {
    console.debug(`${eventType}: `);
    console.debug(event);
  }
}
